/**
 * @file Frontend API client — toolCitationService.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Type definition — Tool Citation Config. */
export interface ToolCitationConfig {
  id: number;
  menuTitle: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

/** Type definition — Tool Citation Response. */
export interface ToolCitationResponse {
  success: boolean;
  data?: ToolCitationConfig;
  message?: string;
}

/** Exported const — DEFAULT TOOL CITATION. */
export const DEFAULT_TOOL_CITATION: Pick<ToolCitationConfig, "menuTitle" | "description"> = {
  menuTitle: "Cite this tool as",
  description:
    'CEPT Research & Development Foundation (2026). ICoMEC (Version 1.0) [Dashboard Tool]. <a href="https://www.ICoMEC.com" target="_blank" rel="noopener noreferrer">www.ICoMEC.com</a>',
};

/** Exported const — tool Citation Service. */
export const toolCitationService = {
  get: async (): Promise<ToolCitationResponse> => {
    const response = await axiosClient.get(API_URLS.TOOL_CITATION);
    return response.data;
  },

  update: async (payload: {
    menuTitle: string;
    description: string;
  }): Promise<ToolCitationResponse> => {
    const response = await axiosClient.put(API_URLS.TOOL_CITATION, payload);
    return response.data;
  },
};
